module.exports = (__webpack_require__(0))(83);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/BrowserWidget.js from dll-reference girder_lib
// module id = 35
// module chunks = 0